import { useQuery } from '@tanstack/react-query';
import ApiService from '../services/api-service';
import { ProductInfo } from 'src/types/common.types';
import { notification } from 'antd';

const fetchProducts = async () => {
  const response = await ApiService.get<ProductInfo[]>('/api/products');
  const data = response.data;
  if (response.status !== 200) {
    notification.error({
      message: 'Không thể lấy danh sách sản phẩm',
    });
    return [];
  }
  return data;
};

const useProducts = () => {
  return useQuery({
    queryKey: ['products'],
    queryFn: fetchProducts,
    staleTime: 1000 * 60 * 5,
  });
};

export default useProducts;
